export default "__VITE_ASSET__robFkRxP__"